import { Translation } from './Translation';

export const ko_KR: Translation = {
  translation: {
    placeholders: {
      notApplicable: '해당 없음',
      placeholder: '플레이스홀더',
      dropdownDefault: '선택',
      typeToFilter: '필터 입력',
      typeToSearch: '검색어 입력',
      textareaDefault: '여기에 입력하십시오',
    },
    errors: {
      textLimit:
        '허용된 문자 수를 초과했습니다. 브리핑 생성을 위해 문자 수를 줄여주십시오.',
    },
    labels: {
      eLab: 'Azelis e-Lab',
      additionalInfo: '참고 (예: 벤치마킹, 데드라인, 기타 타깃 국가 등)',
      price: '예: 2.50~2.89 {{currency}}/{{weightUnit}}',
      targetPackaging: '타킷 패키징',
      notes: '참고',
      attachments: '첨부 파일',
      enterAName: '이름 입력',
      addAttachment: '첨부 파일 추가',
      optional: '옵션',
      loading: '불러오는 중',
      briefing: {
        sent: '전송한 브리핑',
        delivered: '배달 완료 브리핑',
      },
      signIn: '로그인',
      signOut: '로그 아웃',
      requestAccess: '접근 권한 요청',
      multiSelectHint: '다중 선택 가능',
      other: '기타',
      noOptions: '옵션 없음',
      or: '또는',
      // e.g. "Created at 12:00am 12.12.2021"
      createdAt: '생성 일시',
      createdBy: '작성자',
      status: '상태',
      continue: '계속',
      untitled: '제목 없음',
      countries: {
        Benelux: '베네룩스',
        Belgium: '벨기에',
        France: '프랑스',
        Germany: '독일',
        India: '인도',
        Indonesia: '인도네시아',
        Italy: '이탈리아',
        Ireland: '아일랜드',
        Luxembourg: '룩셈부르크',
        Netherlands: '네덜란드',
        'United Kingdom': '영국',
      },
      languages: {
        de_DE: '독일어',
        en_GB: '영어',
        en_US: '영어',
        fr_FR: '프랑스어',
        zh_CN: '중국어',
        ko_KR: '한국인',
      },
      countrySlug: {
        BNL: '베네룩스',
        FR: '프랑스',
        GB: '영국',
        UK: '영국',
        DE: '독일',
        IN: '인도',
        IT: '이탈리아',
        ID: '인도네시아',
        IE: '아일랜드',
      },
      markets: {
        AgriEnvironmental: '농업 & 환경 솔루션',
        FoodNutrition: '식품 & 영양',
        HomeCareIndustrialCleaning: '홈케어 & 산업용 세정',
        HomecareIndustrialCleaning: '홈케어 & 산업용 세정',
        PersonalCare: '퍼스널케어',
        SpecialtyAgriHorti: '',
        FoodHealth: '',
      },
      ofTotal: '{{total}}의',
      perPage: '페이지당:',
      briefingFlowTag: {
        base: '기본',
        colour: '색상',
        fragrance: '향',
        formulation: '포뮬레이션',
      },
    },
    linksOrButtons: {
      details: '상세 정보',
      // e.g. "Back to Applications"
      backTo: '되돌아가기',
      seeProjectOverview: '프로젝트 개요 보기',
      backToOverview: '개요로 되돌아가기',
      backToReview: '리뷰로 이동',
      showMore: '더 보기',
      goToInspiration: '영감 섹션으로 이동',
      startNewFormulation: '새 포뮬레이션 시작',
      toggleMenu: '토글 메뉴',
      navigation: {
        start: '포뮬레이션 시작',
        'project-overview': '내 포뮬레이션',
      },
      backToStart: '시작',
      edit: '편집',
      next: '다음',
      prev: '이전',
      sendBriefing: '브리핑 전송',
    },
    topics: {
      application: {
        name: '적용',
        heading: {
          create: '적용 제품 및 최종 용도는 무엇입니까?',
          fix: '어떤 포뮬레이션 적용을 수정하시겠습니까?',
          enhance: '어떤 포뮬레이션 적용을 개선하시겠습니까?',
          modify: '적용 제품 및 최종 용도는 무엇입니까?',
        },
        levels: {
          '0': {
            normal: '메인 카테고리',
            selected: '메인 카테고리',
            other: '선택 항목 지정',
            otherPlaceholder: '새 메인 카테고리 이름',
            product: '제품 카테고리',
          },
          '1': {
            normal: '하위 카테고리 선택',
            selected: '하위 카테고리',
            other: '선택 항목 지정',
            otherPlaceholder: '새 하위 항목 이름',
            technology: '기술',
          },
          '2': {
            normal: '하나 이상의 특성 선택',
            selected: '특성',
            other: '특성 지정',
            otherPlaceholder: '새 특성 이름',
            endUse: '최종 용도',
            specifyEndUse: '최종 용도 지정',
            endUsePlaceholder: '최종 용도 이름',
          },
        },
      },
      'formulation-attributes': {
        name: '포뮬레이션 속성',
        heading: {
          general: '귀하의 제품이 어떤 포뮬레이션 속성을 가져야 합니까?',
        },
        productMarketingClaims: '제품 마케팅 클레임',
        formulationType: '포뮬레이션 유형',
        texture: '텍스처',
        storage: '보관',
        productForm: '제품 유형',
        otherProductMarketingClaims: '기타 제품 마케팅 클레임 지정',
        otherFormulationType: '기타 포뮬레이션 유형 지정',
        otherTexture: '기타 텍스처 지정',
        otherStorage: '기타 보관 지정',
        options: {
          availableProductMarketingClaims: {
            euEcolabel: '유럽연합 에코라벨(EU Ecolabel)',
            rspoCertified: '팜유 친환경 국제 인증(RSPO)',
            bioBasedProduct: '바이오 베이스 제품/자연 유래',
            nordicSwan: '노르딕스완(Nordic Swan)',
            euEcocert: '유럽연합 에코서트(EU Ecocert)',
            lowCLP: '낮은 CLP (분류) 위험 등급',
            lowToZeroVOC: '낮은 VOC~제로 VOC',
            biodegradable: '(쉬운) 생분해성',
            lowAllergens: '저알레르겐',
            highActive: '하이 액티브',
            nonLabelledForCLP: 'CLP에 대한 라벨 없음',
            mildToSkinAndEyes: '피부와 눈에 자극이 적음',
            easyToHandle: '취급 용이',
            highlyEffectiveLowDosageLevels: '고효율/저용량',
            preservativeFree: '무방부제',
            foodContact: '식품 접촉',
            noAnimalTesting: '동물 실험을 하지 않습니다',
            nanoparticlesFree: '나노입자 프리',
            lowSVHC: '낮은 SVHC',
            natural: '자연적',
            vegan: '비건',
            noHeavyMetals: '중금속 없음',
            soothing: '수딩',
            moisturising: '모이스처라이징',
            sensitiveSkin: '민감성 피부',
            woundProtection: '상처 보호',
            calming: '진정',
            waterSaving: '물 절약',
            antiageing: '안티에이징',
            softFocus: '소프트 포커스',
            wrinkleFilling: '링클필링',
            antiCreasing: '안티크리징',
            longLasting: '롱래스팅',
            easyToApply: '바르기 쉬움',
            quickDrying: '빠른 건조',
            waterProof: '워터프루프',
            highCoverage: '하이커버리지',
            hydrating: '보습',
            oilAbsorbing: '오일 흡수',
            nonBleedingFeathering: '비블리딩/비페더링',
            glossy: '광택',
            kissProof: '키스프루프',
            rubResistant: '문지름 저항성',
            removesWaterproof: '원터프루프 제거',
            gentle: '순함',
            wearResistant: '마모 저항성',
            easyToRemove: '제거하기 쉬움',
            highGlossShine: '고광택/윤기',
            dermatologicallyTested: '피부과 검사 완료',
            antibacterial: '향균성',
            forSensitiveSkin: '민감성 피부용',
            softening: '부드럽게 함',
            detangling: '디탱글링',
            dryDamaged: '건조/손상',
            fineHair: '가는 모발',
            colourProtection: '컬러 프로텍션',
            colourEnhancing: '컬러 향상',
            antiDandruff: '비듬 방지',
            conditioning: '컨디셔닝',
            sulphateFree: '황산염 프리',
            antiBuildUp: '빌드업 방지',
            twoInOne: '2 in 1',
            permanent: '영구적',
            semiPermanent: '반영구적',
            rootTouchUp: '루트 터치업',
            temporary: '일시적',
            treatment: '트리트먼트',
            hairStrengthening: '모발 강화',
            revitalising: '리비탈라이징',
            exfoliating: '각질 제거',
            strengthening: '강화',
            damageRepair: '손상 복구',
            thickening: '굵기 증가',
            protection: '보호',
            protecting: '보호',
            strongHold: '강력한 고정',
            improvedComfort: '편안함 향상',
            foodseal: '음식물 끼임 방지',
            gumCare: '잇몸 관리',
            whitening: '화이트닝',
            alcoholFree: '알코올 프리',
            enamelCare: '에나멜 케어',
            sensitive: '민감성',
            antiseptic: '살균',
            antiBacterial: '항균성',
            antiAgeing: '안티에이징',
            antioxidant: '산화 방지',
            antiPollution: '오염 방지',
            repair: '리페어',
            skinTightening: '피부 타이트닝',
            illuminatingBrightning: '일루미네이팅/브라이트닝',
            antiPuffinessDark: '안티퍼핀/다크서클',
            cycles: '사이클',
            purifying: '정화',
            oilControl: '오일 컨트롤',
            cooling: '쿨링',
            extraFirmHold: '매우 단단한 고정',
            firmHold: '단단한 고정',
            lightHold: '가벼운 고정',
            curlDefining: '컬 디파이닝',
            volumising: '볼류마이징',
            mediumHold: '미디움 고정',
            flexibleHold: '유연한 고정',
            shine: '윤기',
            weatherproof: '비바람에 잘 견딤',
            uvProtection: '자외선 차단',
            waterResistant: '물 저항성',
            floral: '플로럴',
            fougère: '푸제르',
            aromatic: '아로마틱',
            woody: '우디',
            citrus: '시트러스',
            amber: '엠버',
            chypre: '시프레',
            fruity: '과일 향',
            gourmand: '구르망',
            musk: '머스크',
            spicy: '스파이시',
            cleanLabel: '클린라벨(Clean label)',
            naturalColours: '천연 색소',
            naturalFlavours: '천연 향',
            glutenFree: '글루텐 프리',
            allergenFree: '알레르겐 프리',
            palmFree: '팜 프리',
            nanoFree: '나노 프리',
            noReducedFat: '무지방/저지방',
            noReducedSugar: '무설탕/저설탕',
            noReducedSalt: '무염/저염',
            sourceHighFiber: '식이섬유의 원천/ 함량 높음',
            sourceHighProtein: '단백질의 원천/함량 높음',
            sourceHighVitaminsMinerals: '비타민과 미네랄의 원천/함량 높음',
            healthBenefices: '건강에 좋음',
            veganVegetarianAnimalFree: '비건/베지테리언/동물질을 포함하지 않음',
            organic: '유기농',
            fairTrade: '공정거래',
            halal: '할랄',
            kosher: '코셔',
            sweatReduction: '',
            odourProtection: '',
            aluminiumFree: '',
            noWhitening: '',
            invisible: '',
            refreshing: '',
            moisturizing: '',
          },
          availableFormulationTypes: {
            owEmulsion: 'O/W 에멀전',
            woEmulsion: 'W/O 에멀전',
            waterBased: '워터 베이스',
            oilBased: '오일 베이스',
            emulsion: '에멀전',
            anhydrous: '무수',
            alcoholic: '알코올 포함',
            nonAlcoholic: '비알코올',
            other: '기타',
            solidStick: '',
            gelStick: '',
            aerosolSpray: '',
            nonAerosolSpray: '',
            cream: '',
            rollOn: '',
            powder: '',
          },
          availableTextures: {
            fluid: '유체',
            spray: '스프레이',
            serum: '세럼',
            aerosol: '에어로졸',
            gel: '젤',
            lotion: '로션',
            cream: '크림',
            solid: '고형',
            foam: '폼',
            powder: '파우더',
            liquid: '액체',
            tablet: '정제',
            stick: '스틱',
            bar: '바',
            nonAerosol: '비에어로졸',
            other: '기타',
            soft: '',
            emulsion: '',
          },
          availableStorage: {
            ambient: '상온',
            bakeryDryBlend: '베이커리 블렌드/드라이 블렌드',
            instantDryBlend: '인스턴트 (드라이 블렌드)',
            frozen: '냉동',
            bestBefore: '유통기한',
            pasteurisation: '저온살균',
            chilled: '냉각',
            bakeStability: '내열성 (전자레인지)',
          },
          availableProductForm: {
            powder: '파우더',
            liquid: '액체',
            granules: '과립제',
            flakes: '플레이크',
            paste: '페이스트',
            wax: '왁스',
            prills: '알갱이',
            needles: '바늘',
            piece: '피스',
            emulsion: '에멀전',
          },
        },
        errors: {
          productMarketingClaims: '마케팅 클레임 로드 중 오류 발생',
        },
      },
      fragrance: {
        name: '향',
        heading: {
          general: '포뮬레이션에 향을 더하세요',
        },
        fragranceFormulation: '포뮬레이션에 향을 더하고 싶으신가요?',
        attributesFulfill: '어떤 향의 속성을 원하시나요?',
        requirements: '향이  준수해야 할 요건이 있나요?',
        colourOrConcept: '콘셉트/색상',
        CMR: 'CMR (발암성, 돌연변이성, 생식독성 물질)',
        direction: '향 지침',
        mustComply: '향은 반드시 다음을 준수해야 합니다:',
        maxAllergensOnLabel: '라벨의 최대 알레르겐 수',
        requestedApplicationDosage: '요구 적용 정량(%)',
        fragranceSamples: '향 샘플이 필요하십니까?',
        requiredSampleTime: {
          heading: '언제까지 샘플이 필요하시나요?',
          label: '요구 샘플 일자',
        },
        largerFragranceSize: {
          heading: '샘플당 10g보다 큰 향 샘플이 필요한지 지정하십시오.',
          label: '더 큰 샘플 크기',
        },
        specifyFragranceMustOther: '기타 지정',
        options: {
          confirmFragranceOptions: {
            yes: '예',
            no: '아니요',
          },
          availableColoursOrConcepts: {
            black: '검은색',
            silver: '은색',
            white: '흰색',
            blue: '파란색',
            yellow: '노란색',
            pink: '분홍색',
            purple: '보라색',
            green: '녹색',
            orange: '주황색',
            gold: '금색',
            natural: '자연적',
            clean: '깨끗함',
            care: '케어',
            hygiene: '위생',
            malodour: '악취',
            performance: '성취',
            premium: '프리미엄',
          },
          availableDirection: {
            citrus: '시트러스',
            chypre: '시프레',
            floral: '플로럴',
            floriental: '플로리엔탈',
            fruity: '과일 향',
            gourmand: '구르망',
            green: '녹색',
            herbal: '허브',
            lavender: '라벤더',
            musk: '머스크',
            oriental: '오리엔탈',
            pine: '파인',
            spicy: '스파이시',
            woody: '우디',
          },
          availableCMR: {
            notAllowed: '허용되지 않음',
            allowedButOilNotLabelled: '허용되지만 CMR 라벨이 없는 오일',
            allowed: '허용',
          },
          mustComply: {
            noAllergensOnOil: '오일에 알레르겐 없음',
            noAllergensOnFinalProduct: '최종 제품에 알레르겐 없음',
            pCMNMFree: 'PCM/NM 프리',
            ecoLabel: '에코라벨',
            okotestCandidate: '외코테스트 응시',
            vegan: '비건',
            other: '기타',
          },
        },
      },
      'processing-capabilities': {
        name: '처리 능력',
        heading: {
          general: '귀하 제품의 처리 능력은 무엇입니까?',
        },
        bakeStability: '내열성',
        bakingTime: '베이킹 시간 (분)',
        bakingTemperature: '베이킹 온도 (°C)',
        fillingTime: '충전 시간 (분)',
        fillingTemperature: '충전 온도 (°C)',
        mixingStepDetails: '혼합 단계 세부 정보 (high shear / paddle stirrer)',
        productPh: '제품의 pH',
        brix: '브릭스 (가용성 고체)',
        processingCapabilitiesPackagingDetails: '패키징 유형 및 세부 정보',
        foodSafetyDetails: '식품 안전 (저온살균 /UHT)',
        processingHotCold: '저온/고온 처리',
        homogenisation: '균질화',
        otherProcessingCapabilities: '기타 처리 능력',
      },
      restrictions: {
        name: '제한 사항',
        heading: {
          general: '포뮬레이션이 준수해야 하는 제한 사항이 있습니까?',
        },
        requirements: '요구 사항',
        restrictions: '제한 사항',
        can: '가능',
        must: '필수',
        mustComply: '포뮬레이션은 반드시 다음을 준수해야 합니다:',
        canComply: '포뮬레이션은 다음을 준수할 수 있습니다:',
        requirementsMust: '요구 사항 - 필수',
        requirementsCan: '요구 사항 - 가능',
        restrictionsMust: '제한 사항 - 필수',
        restrictionsCan: '제한 사항 - 가능',
        specifyRequirements: '요구 사항 지정',
        specifyRestrictions: '제한 사항 지정',
        options: {
          silictions: '실리콘 없음',
          parabens: '파라벤 없음',
          oil: '미네랄 오일 기반 성분 없음',
          emulsifier: '유화제 프리',
          preservatives: '방부제 없음',
          ethanol: '에탄올 프리',
          cold: '1차 생산 기법',
          polymore: '합성고분자 프리',
          uv: '유기 자외선 필터 없음',
          nanomaterial: '나노 물질 없음',
          sulfate: '황산염 프리',
          surfactant: '저계면활성제',
          tears: '눈물 포뮬레이션 없음',
          talc: '탈크 프리',
          notApplicable: '해당 없음',
          other: '기타',
        },
        errors: {
          restrictions: '제한 사항 로드 오류',
        },
      },
      requirements: {
        name: '요구 사항',
        heading: {
          general: '포뮬레이션이 준수해야 할 요구 사항이 있습니까?',
          specify: '기타 포뮬레이션 요구 사항을 지정해 주십시오',
        },
        requirements: '요구 사항',
        can: '가능',
        must: '필수',
        mustComply: '포뮬레이션은 반드시 다음을 준수해야 합니다:',
        canComply: '포뮬레이션은 다음을 준수할 수 있습니다:',
        requirementsMust: '요구 사항 - 필수',
        requirementsCan: '요구 사항 - 가능',
        specifyRequirements: '요구 사항 지정',
        applicationConditionDetails: {
          heading:
            '적용 조건(표면 또는 토양 유형, 온도 범위 등)에 대한 세부 사항을 표시하십시오.',
          label: '적용 조건 세부 정보',
        },
        pHRange: {
          heading: '어떤 pH 범위에서 제품이 활성화되어야 합니까?',
          label: 'pH 범위',
        },
        aggressiveComponents: {
          heading: '포뮬레이션의 공격적 구성 요소를 나열하십시오.',
          label: '공격적 구성 요소',
        },
        lightStability: {
          heading: '내광성 중요한가요?',
          label: '내광성',
          answer: {
            yes: '예',
            no: '아니요',
          },
        },
        options: {
          biodegradable: '(쉬운) 생분해성',
          bioBased: '바이오 베이스 제품/자연 유래',
          carBody: '카바디샵 규정 준수',
          coldPress: '1차 생산 기법',
          easyToHandle: '취급 용이',
          euEcocert: '유럽연합 에코서트',
          euEcolabel: '유럽연합 에코라벨',
          foodContact: '식품 접촉',
          halal: '할랄',
          highActive: '하이 액티브',
          highlyEffectiveLowDosageLevels: '고효율/저용량',
          kosher: '코셔',
          lowAllergens: '저알레르겐',
          lowCLP: '낮은 CLP (분류) 위험 등급',
          lowSVHC: '낮은 SVHC',
          lowToZeroVOC: '낮은 VOC~제로 VOC',
          mildToSkinAndEyes: '피부와 눈에 자극이 적음',
          nanoparticlesFree: '나노입자 프리',
          natural: '자연적',
          noAnimalTesting: '동물 실험을 하지 않습니다',
          noHeavyMetals: '중금속 없음',
          nonLabelledForCLP: 'CLP에 대한 라벨 없음',
          nordicSwan: '노르딕스완',
          palmFree: '팜 프리',
          phosphorFree: '인광 물질 프리',
          preservativeFree: '무방부제',
          rspoCertified: '팜유 친환경 국제 인증(RSPO)',
          vegan: '비건',
          notApplicable: '해당 없음',
          other: '기타',
        },
        errors: {
          requirements: '요구 사항을 로드하는 중 오류가 발생했습니다.',
        },
      },
      colour: {
        name: '색상',
        heading: {
          general: '귀하 포뮬레이션에 색을 더하세요.',
        },
        formulationColoured: '귀하의 포뮬레이에션 색을 첨가하시겠습니까?',
        colourAttributes: '어떤 착색제 속성을 원하시나요?',
        colourShades: '색상',
        colourSamples: {
          label: '색상 샘플',
          heading: '색상 샘플이 필요하신가요?',
        },
        requiredTime: {
          heading: '언제까지 샘플이 필요하시나요?',
          label: '요구 샘플 일자',
        },
        labSupport: {
          heading: 'Miliken  연구소의 도움이 필요하십니까? ',
          label: '공급업체 연구소의 도움이 필요하십니까?',
        },
        options: {
          confirmColourOptions: {
            yes: '예',
            no: '아니요',
          },
          shades: {
            cyanBlue: '청록색',
            royalBlue: '로얄 블루',
            darkBlue: '다크 블루',
            brightBlue: '브라이트 블루',
            aquamarineBlue: '아쿠아마린 블루',
            brightGreen: '브라이트 그린',
            green: '녹색',
            brightYellow: '브라이트 옐로우',
            lemonYellow: '레몬 옐로우',
            darkYellow: '다크 옐로우',
            yellow: '노란색',
            orange: '주황색',
            fluorescentYellow: '형광 노란색',
            brightViolet: '브라이트 바이올렛',
            purple: '보라색',
            darkViolet: '다크 바이올렛',
            darkRed: '다크 레드',
            fluorescentPink: '형광 분홍색',
            brightPink: '브라이트 핑크',
            softPink: '소프트 핑크',
          },
        },
      },
      'target-consumer': {
        name: '타깃 소비자',
        heading: {
          general: '귀하의 타깃 소비자는 누구입니까?',
        },
        age: '나이',
        targetConsumerAge: '타깃 소비자 나이',
        gender: '성별',
        targetConsumerGender: '타깃 소비자 성별',
        buttons: {
          genders: {
            female: '여성',
            male: '남성',
            allGenders: '모든 성별',
          },
          allAges: '모든 연령',
        },
      },
      'additional-info': {
        name: '추가 정보',
        heading: {
          general: '추가하실 사항이 있나요?',
        },
        additionalInfo: '추가 정보',
        additionalInfoFiles: '추가 정보 파일',
      },
      price: {
        name: '가격',
        heading: {
          general: '포뮬러 예상 비용은 얼마입니까?',
          base: '기본 포뮬레이션 예상 비용은 얼마입니까?',
          color: '색상 추가 예상 비용은 얼마입니까?',
          fragrance: '향 추가 예상 비용은 얼마입니까?',
        },
      },
      'product-details': {
        name: '제품 상세 정보',
        heading: {
          general: '제품 상세 정보를 지정하십시오',
        },
        finishedProductSamples: {
          heading: '완성된 제품의 샘플이 필요합니까?',
          answer: {
            yes: '예',
            no: '아니요',
          },
          requiredTimeForSample: '예라고 답하신 경우, 요구 샘플 일자',
        },
        finishedProductPotential: '완제품의 제품화 가능성은?  (t/년)',
        projectDeadline: '프로젝트 데드라인',
      },
      packaging: {
        name: '패키징',
        heading: {
          general: '귀하의 타깃 패키징은 무엇입니까?',
        },
        options: {
          pumpDispenser: '펌프 디스펜서',
          sprayDispenser: '스프레이 디스펜서',
          jar: '단지',
          tube: '튜브',
          aerosol: '에어로졸',
          sachet: '봉지',
          bagInCan: '백인캔(Bag-in-can)',
          airPump: '에어펌프',
          bag: '백',
          carton: '상자',
          bottle: '병',
          compact: '컴팩트',
          jarBottle: '단지-병',
          other: '기타',
        },
      },
      'modification-type': {
        name: '변경 유형',
        heading: {
          general: '포뮬레이션의 어떤 부분을 변경하시겠습니까?',
          type: '변경 유형',
        },
        options: {
          base: '기본 포뮬레이션 변경',
          colour: '색상 변경',
          fragrance: '향 변경',
        },
      },
      'modification-issue': {
        name: '변경',
        heading: {
          general: '무엇을 변경하고 싶으신가요?',
        },
        explainIssue: '문제를 설명해 주세요.',
      },
      problem: {
        name: '문제',
        fix: {
          name: '도전 과제',
        },
        enhance: {
          name: '개선',
        },
        heading: {
          fix: '포뮬레이션 관련 직면한 도전 과제는 무엇입니까?',
          enhance: '포뮬레이션을 어떻게 개선하고 싶으신가요?',
        },
      },
      ingredients: {
        name: '성분',
        heading: {
          general: '현재 포뮬레이션에서 사용하는 성분은 무엇입니까?',
        },
        azelisRawMaterials: 'Azelis의 원료',
        rawMaterials: '원료',
        rawMaterial: '원료',
        rawMaterialFiles: '원료 파일',
        ingredientsFiles: '성분 파일',
        upload: '여기에 포뮬레이션을 업로드하거나 아래에 원료를 추가하십시오.',
        other: '원료 (예: 물, 실리카, 카프릴릴 글리콜 등)',
      },
      'active-ingredients': {
        name: '유효 성분',
        heading: {
          general: '포뮬레이션의 유효 성분은 무엇입니까?',
        },
        chooseActiveIngredient: '유효 성분 선택',
        concentration: '농도 [g/L]',
        addAnother: '다른 유효 성분 추가',
      },
      'active-function': {
        name: '활성 기능',
        heading: {
          general: '포뮬레이션에 추가 성분을 추가하시겠습니까?',
          review: '기능',
        },
        adjuvant: {
          name: '보조제',
          choose: '보조제 선택',
        },
        stabilizer: {
          name: '안정제',
          choose: '안정제 선택',
        },
        emulsifier: {
          name: '유화제',
          choose: '유화제 선택',
        },
        liquidColorant: {
          name: '액체 착색제',
          choose: '액체 착색제 선택',
        },
        solvent: {
          name: '용매',
          choose: '용매 선택',
        },
      },
      formulations: {
        name: '포뮬레이션',
      },
      review: {
        name: '리뷰',
      },
    },
    modals: {
      cancelBriefing: {
        prompt: '브리핑을 취소하시겠습니까?',
        content: '기존 입력이 모두 삭제됩니다.',
        confirm: '예',
        cancel: '아니요',
      },
      customerSelection: {
        prompt: '사용자 지정',
        content: '귀하 포뮬레이션의 고객과 사용자 고객을 선택하십시오',
        form: {
          customer: '고객',
          customerUser: '사용자 고객',
        },
        confirm: '확인',
        cancel: '취소',
        footer:
          'Azelis e-Lab을 나가고 싶으시면 <link1 label="sign out here"/> 또는 여기로 이동 <link2 label="Azelis Customer Portal"/>',
        error: {
          heading: '문제가 발생했습니다.',
          messages: {
            loadingCustomer: '고객 옵션을 로드할 수 없습니다.',
            loadingCustomerUser: '이 고객의 사용자를 로드할 수 없습니다.',
            settingCustomerUser:
              '이 사용자에 대한 사용자 프로필을 로드하는 중 문제가 발생했습니다.',
          },
          content:
            '다시 시도하세요. 문제가 계속되면, 로그아웃하고 다시 로그인하거나 여기로<link1 label="contact Azelis support"/>연락해 주세요.',
          confirm: '다시 시도',
          cancel: '로그아웃하고 다시 시도하세요.',
          cannotSelectEmployeeUsers: 'employee users를 선택할 수 없습니다',
        },
      },
      changeCustomerSelection: {
        change: '변경',
        prompt: '현재 이용 중인 사용자를 변경하시겠습니까?',
        confirm: '예, 변경합니다',
        cancel: '계속',
      },
      deleteUploadedFile: {
        prompt: '파일을 삭제하겠습니까?',
        confirm: '예, 삭제',
        cancel: '취소',
      },
    },
    components: {
      briefingSelection: {
        heading: '어떻게 시작하시겠습니까?',
        buttons: {
          create: {
            title: '생성',
            copy: '새 포뮬레이션',
          },
          enhance: {
            title: '개선',
            copy: '기존 포뮬레이션',
          },
          modify: {
            title: '변경',
            copy: '기존 포뮬레이션',
          },
          fix: {
            title: '수정',
            copy: '기존 포뮬레이션',
          },
        },
        inspirationLink: '기존 포뮬레이션에서 영감을 얻으세요',
        loading: '필요한 데이터를 로드하는 동안 잠시 기다려 주십시오',
      },
      stepPackaging: {
        packagingSamplePrompt:
          '패키징을 소유하고 있다면, 귀하의  요구에 맞게 포뮬레이션을 최적화할 수 있도록 패키징을 당사에 보내주시기 바랍니다. 귀하의 브리핑에 맞출 수 있도록 이름과 프로젝트 이름을 동봉해 주십시오.',
        addressLabel: '주소',
        otherPackaging: '기타 패키징 지정',
      },
      review: {
        heading: '리뷰',
        productName: '프로젝트 이름',
      },
      success: {
        // The \n here creates a new line, and should not be translated
        heading: '감사합니다! \n 문의가 성공적으로 전송되었습니다.',
        emailInfo: '요약한 내용을 귀하의 이메일로 보내드렸습니다.',
        whatsNext: {
          heading: '다음 단계는 무엇인가요?',
          review: '귀하의 브리핑을 전문가가 검토합니다.',
          contact: '계정 관리자가 곧 연락드릴 것입니다.',
        },
        recommendations: {
          heading: '더 많은 영감이 필요하신가요?',
          subheading:
            '귀하의 용도에 맞는 몇 가지 포뮬레이션과 성분이 더 있습니다:',
          noDescription: '설명 없음',
        },
      },
      projectOverview: {
        heading: '포뮬레이션 개요',
        emptyFormulations: '귀하의 포뮬레이션이 아직 없습니다',
        createFormulation: '포뮬레이션 생성',
        myFormulations: '내 포뮬레이션',
        // {{team}} = customer name or translation from "team"  below
        teamFormulations: '{{team}} 포뮬레이션',
        team: '팀',
        filter: {
          country: '국가별로 필터',
          market: '시장별로 필터',
          application: '적용별로 필터',
        },
        resetAllFilters: '모든 필터 삭제',
      },
      projectDetails: {
        projectType: {
          heading: '프로젝트 유형',
          create: '새 포뮬레이션 생성',
          enhance: '기존 포뮬레이션 개선',
          fix: '기존 포뮬레이션 수정',
        },
        referenceId: '기준 아이디',
        formulationSpecifics: '포뮬레이션 세부 사항',
        fileDownloadHelp:
          '새 탭에서 파일이 열리면, ctrl + s (윈도우) 또는 cmd + s (맥)를 사용하여 파일을 저장하시기 바랍니다.',
      },
      account: {
        heading: '내 계정',
        name: '이름',
        email: '이메일 주소',
        selectedMarket: '선택 시장',
      },
      fileUpload: {
        fileListLabel: '첨부 파일',
        privacy:
          '귀하의 데이터 업로드는 안전하며 제3자와 공유되지 않습니다. 오직 Azelis만이  프로젝트의 배경에서 귀하에게 최상의 결과를 보장하기 위해 이 데이터를 사용합니다.',
      },
      customerSelectionBar: {
        onBehalf: '귀하는 다음을 대신해 포뮬레이션을 하고 있습니다:',
      },
      intro: {
        heading: {
          main: '새로운Azelis e-Lab에서 모든 전문 기술 지식에 쉽게 접근하실 수 있습니다.',
          about: 'e-Lab 소개',
        },
        content: {
          main: '새로운 e-Lab by Azelis 은 새로운 포뮬레이션을 만들거나 기존 포뮬레이션을 개선하는  데 가장 현명한 방법입니다. 전문가에게 직접 문의하여 시장 진입 절차를 단축하세요!',
          benefits: [
            '기존 포뮬레이션 수정 또는 개선',
            '새로운 혁신적인 포뮬레이션 만들기',
            'Azelis의 기술 전문가와 직접 연락하기',
            '연중무휴로 이용 가능',
            '지금 시작하세요!',
          ],
        },
      },
      signIn: {
        passwordLabel: '비밀번호',
        email: '이메일 주소',
        // $t(labels:requestAccess) = "Request access", from the further up translation string
        signUp: '아직 계정이 없으신가요?  $t(labels:requestAccess)!',
        loginWithCustomerPortal: 'Customer Portal 로그인',
        pleaseWait: '로그인하는 동안 잠시 기다려 주세요.',
        errors: {
          errorEmpty: '이메일과 비밀번호를 입력하세요.',
          errorIncorrect: '입력한 이메일과 비밀번호의 조합이 맞지 않습니다.',
          errorServerside: '오류가 발생했습니다. 잠시 후 다시 시도해주세요',
          errorCustomerPortalLogin:
            'Customer Portal 프로필에 접근할 수 없습니다.',
          access_denied: '허가가 거부된 듯합니다. 다시 시도하세요.',
        },
      },
      footer: {
        partOfAzelis: 'Azelis Customer Portal의 일부분',
        copyright: 'Copyright © Azelis {{year}}. All rights reserved.',
        links: {
          cookie: '쿠키 정책',
          privacy: '개인정보 취급방침',
          terms: '이용 약관',
        },
      },
      countryMarketSelector: {
        reason: {
          empty: {
            heading: '국가나 시장이 선택되지 않았습니다.',
            body: '아직 선택된 국가나 시장이 없습니다. 아래 사용 가능한 옵션 중 하나를 선택하십시오:',
            universalCustomer: {
              heading: '선택된 고객, 국가 또는 시장이 없습니다.',
              body: '아직 선택된 고객, 국가 또는 시장이 없습니다. 아래 사용 가능한 옵션 중 하나를 선택하십시오:»',
            },
          },
          invalid: {
            heading: '유효하지 않은 국가 또는 시장 선택',
            body: '선택한 국가 또는 시장이 유효하지 않습니다. 아래 사용 가능한 옵션 중 하나를 선택하십시오:',
            universalCustomer: {
              heading: '유효하지 않은 선택',
              body: '선택한 고객, 국가 또는 시장이 유효하지 않습니다. 아래 사용 가능한 옵션 중 하나를 선택하십시오:',
            },
          },
          preferences: {
            heading: '환경 설정',
            body: '환경 설정을 변경하면 사용할 수 있는 콘텐츠에 영향을 미칩니다.',
          },
        },
        customer: '회사',
        country: '국가',
        market: '시장',
        preferredLanguage: '기본 언어',
        confirm: '확인',
        cancel: '취소',
      },
      error404: {
        heading: '페이지를 찾을 수 없습니다',
        body: '해당 URL에서 아무것도 찾을 수 없습니다. 메뉴를 사용하여 탐색하거나 링크를 다시 확인해 보세요. ',
      },
      noCountryMarketAvailable: {
        heading: '유효한 국가 또는 시장이 없습니다.',
        body: '사용자 프로필이e-Lab에서 지원하는 국가/세분화 시장과 연결되어 있지 않은 듯합니다. 시스템 관리자에게 연락해 주시기 바랍니다.',
      },
      filters: {
        filter: '필터',
      },
    },
    emails: {
      customer: {
        subject: 'Azelis e-Lab 이 포뮬레이션 브리핑을 접수하였습니다',
        html: {
          introNotCreatedByEmployee:
            // {{branch}} = "create", "fix"  or "enhance"
            // {{branchFormulationPrefix}} = "a new"  or "an existing"
            '감사합니다!  {{branch}} {{branchFormulationPrefix}}에 대한 귀하의 브리핑이 Azelis 기술 전문가에게 성공적으로 전송되었습니다.',
          introCreatedByEmployee:
            // Same as above
            '{{employeeCreatorName}}이 귀하를 대신하여 {{branch}} {{branchFormulationPrefix}}에 대한 브리핑을 생성했습니다. Azelis 기술 전문가에게 성공적으로 전송되었습니다.',
          newFormulationPrefix: '새 포뮬레이션',
          existingFormulationPrefix: '기존 포뮬레이션',
          heading: 'e-Lab에 새로운 브리핑이 생성되었습니다.',
          // {{customerName}} = e.g "John Smith"
          line1: '{{customerName}} 귀하,',
          line2:
            '전문가 팀이 귀하의 브리핑을 검토한 후 곧 연락을 드릴 것입니다.',
          line3: '아래에서 제공하신 정보의 요약을 확인하실 수 있습니다.',
          referenceId: '기준 아이디',
          projectName: '프로젝트 이름',
          marketSegment: '세분화 시장',
          country: '국가',
          thankYou: 'Azelis e-Lab을 이용해 주셔서 감사합니다..',
          inspirationLinkText: '영감',
          inspirationSuggestion:
            // {{inspirationLink}} = just the word "inspiration", but it" s a link
            'Azelis 전문가의 최신 업계 동향과 새로운 시장에 대한 통찰력을 놓치지 않으시려면 여기{{- inspirationLink}} 를 방문해 보시기 바랍니다.',
          theAzelisTeam: 'Azelis 팀',
          copyright: 'Copyright © Azelis {{year}}. All rights reserved.',
        },
      },
      lab: {
        // {{byDisplayName}} = either "John Smith"  or "John Smith for Sam Samson"
        subject: '{{byDisplayName}}이 생성한 Azelis e-Lab 포뮬레이션 브리핑',
        // {{byMe}} and {{forMe}} are both just names
        byFor: '{{forMe}}위해 {{byMe}} 생성',
        html: {
          line1:
            // {{branch}} = "create", "fix"  or "enhance"
            // {{branchFormulationPrefix}} = "a new"  or "an existing"
            // {{byDisplayName}} = same as above
            '{{byDisplayName}}이/가 Azelis e-Lab에 {{branch}} {{branchFormulationPrefix}}에 대한 새 브리핑을 발행하였습니다.',
          referenceId: '기준 아이디:',
          createdAt: '생성 일시:',
          projectName: '프로젝트 이름:',
          pleaseContact:
            // {{- mailToLink}} = an email address, but it" s also a link
            '자세한 내용은 여기{{- mailToLink}}로 문의하시기 바랍니다.',
          unnamedProject: '이름 없는 프로젝트',
          yourAzelisTeam: '귀하의 Azelis e-Lab 팀',
        },
      },
      auxiliary: {
        // will be inserted for {{branch}} in the emails section
        branch: {
          create: '생성',
          enhance: '개선',
          modify: '변경',
          fix: '수정',
        },
      },
    },
  },
};
